import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDszBnTeCspjfjlgR6FEl0fCf6fxFTTaSs",
  authDomain: "video-assistant-1780a.firebaseapp.com",
  databaseURL: "https://video-assistant-1780a-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "video-assistant-1780a",
  storageBucket: "video-assistant-1780a.firebasestorage.app",
  messagingSenderId: "987465774016",
  appId: "1:987465774016:web:9763bbfb19334619e84e25",
  measurementId: "G-QHG3NDKY8B"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export default db;